import dayjs from 'dayjs'
import isNil from 'lodash/isNil'

export enum SortingPlacement {
  Before = -1,
  Tie = 0,
  After = 1,
}

/**
 * A function that compares optional dates, with undefined dates placed according to the `undefinedPlacement` prop.
 *
 * NOTE: more recent dates (higher value) are SortingPlacement.After, while older dates (lower value) are SortingPlacement.Before.
 * */
export function compareOptionalDates(
  a: Date | dayjs.Dayjs | undefined | null,
  b: Date | dayjs.Dayjs | undefined | null,
  undefinedPlacement: SortingPlacement
) {
  if (!a !== !b) {
    return !a ? undefinedPlacement : -undefinedPlacement
  }
  if (!a || !b) {
    return SortingPlacement.Tie
  }
  const aTime = a instanceof Date ? a.getTime() : a.valueOf()
  const bTime = b instanceof Date ? b.getTime() : b.valueOf()
  return aTime - bTime
}

/** A function that compares potentially undefined numbers, with undefined numbers placed according to the `undefinedPlacement` prop */
export function compareOptionalNumbers(
  a: number | undefined | null,
  b: number | undefined | null,
  undefinedPlacement: SortingPlacement
) {
  if (isNil(a) !== isNil(b)) {
    return isNil(a) ? undefinedPlacement : -undefinedPlacement
  }
  if (isNil(a) || isNil(b)) {
    return SortingPlacement.Tie
  }

  return a - b
}
